import { Confirm } from 'canoe';
import React from 'react';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  onDelete: () => void;
}

const DeleteDocument = ({ isOpen, toggle, onDelete }: Props) => {
  const handleDelete = () => {
    onDelete();
    toggle();
  };

  if (!isOpen) {
    return null;
  }
  return (
    <Confirm
      severity="Danger"
      title="Are you sure you want to delete this Document?"
      message="Once deleted, this Document and its associated data will be deleted permanently."
      confirmButton={{ children: `Delete Document` }}
      withCheckbox
      onClose={toggle}
      onConfirm={handleDelete}
    />
  );
};

export default DeleteDocument;
